module.exports = __webpack_public_path__ + "flexslider-icon.9c9cb7a6055043933ba6.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/~/flexslider/fonts/flexslider-icon.eot
// module id = ../../../../flexslider/fonts/flexslider-icon.eot
// module chunks = 29